import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import "./styles/_product-position-title.scss"

export interface ProductPositionTitleProps extends WithClassName {
  title: string
  hasClarificationRequest?: boolean | null
  showClarificationRequestIndicator?: boolean
}

export const ProductPositionTitle = React.memo(
  ({
    className,
    title,
    hasClarificationRequest,
    showClarificationRequestIndicator
  }: ProductPositionTitleProps) => {
    const { t } = useTranslation()

    return (
      <div className={classNames("product-position-title", className)}>
        <Icon
          name={IconName.PRODUCTS}
          className="product-position-title__icon"
        />
        <span className="product-position-title__text">{title}</span>
        {showClarificationRequestIndicator && hasClarificationRequest ? (
          <div className="product-position-title__cr-indicator">
            <span className="visually-hidden">
              {t("ClarificationRequest.Indicator")}
            </span>
            <Icon name={IconName.CLARIFICATION_REQUEST} />
          </div>
        ) : null}
      </div>
    )
  }
)
